// App utils
import { datajs } from '../shared/utils';

(function() {
	const toggleSiteNav = () => {
		if (document.body.classList.contains('has-menu')) {
			hideSiteNav();
		} else {
			// Transition CSS class 1
			document.body.classList.add('has-activated-menu');

			// Transition CSS class 2
			setTimeout(function() {
				document.body.classList.add('has-menu');
			}, 10);

			datajs('off-canvas-toggle').forEach(item => {
				item.setAttribute('aria-expanded', 'true');
			});

			datajs('off-canvas-hide').forEach(item => {
				item.setAttribute('aria-expanded', 'true');
			});
		}

		return false;
	};

	const hideSiteNav = () => {
		// Remove Transition CSS class 2
		document.body.classList.remove('has-menu');

		// Remove Transition CSS class 1
		setTimeout(function() {
			document.body.classList.remove('has-activated-menu');
		}, 500);

		datajs('off-canvas-toggle').forEach(item => {
			item.setAttribute('aria-expanded', 'false');
		});

		datajs('off-canvas-hide').forEach(item => {
			item.setAttribute('aria-expanded', 'false');
		});

		return false;
	};

	const toggleSubNav = e => {
		e.preventDefault();
		const icon = e.target;
		icon.closest('.c-navItem').classList.toggle('is-active');
	};

	const handleDocumentKeyUp = e => {
		// Close menu using Esc key.
		if (e.keyCode === 27 && document.body.classList.contains('has-menu')) {
			hideSiteNav();
		}
	};

	const offCanvasNav = () => {
		datajs('off-canvas-toggle').forEach(item => item.addEventListener('click', toggleSiteNav));
		datajs('off-canvas-hide').forEach(item => item.addEventListener('click', hideSiteNav));
		// datajs('subnav-toggle').forEach(item => item.addEventListener('click', toggleSubNav));
		document.querySelectorAll('#menu-huvudmeny .c-navItem--parent > a').forEach(item => item.addEventListener('click', toggleSubNav));

		// Handle document keyup event
		document.addEventListener('keyup', handleDocumentKeyUp);
	};

	document.addEventListener('DOMContentLoaded', offCanvasNav);
})();
